import React from 'react';
import { Button } from 'react-bootstrap';
import { translate } from 'react-i18next';

import history from '../history';

export default translate(['ui'])(({ t, children }) => (
  <div className="default-form">
    <div className="default-left-form">
      <div style={{ fontSize: 20, marginTop: 40, height: 24 }}>{t('Welcome')}</div>
      <div style={{ fontSize: 14, marginTop: 22, height: 33 }}>{t('Login_demo_welcome')}</div>
      <div>
        <Button
          name="demo"
          className="buttons-login"
          type="submit"
          bsStyle="primary"
          style={{ marginTop: 55 }}
          onClick={() => history.push('/demo')}
        >
          {t('DEMO - VERSION')}
        </Button>
      </div>
    </div>
    {children}
  </div>
));



// WEBPACK FOOTER //
// ./components/SecurityDefaultForm.jsx